<template>
  <v-container fluid class="bg-grey">
    <img class="mail-form-picto" src="/images/email_icon_neu_formularfeld.png">
    <v-container class="content">
      <v-row>
        <v-col>
          <h3 class="text-center">
            <span>
              <strong>Unverbindliche Beratung</strong> Anfordern
            </span>
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <Form />
      </v-row>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
  .bg-grey {
    position: relative;
    z-index: 9;
    background-color: #FFE0DF;
  }

  .mail-form-picto {
    position: absolute;
    z-index: 10;
    border: 19px solid white;
    border-radius: 100%;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -60px;
  }

  .max-width-1160 {
    max-width: 1160px;
    margin: 1.5rem auto 0 auto;
  }

  h3 {
    span {
      font-family: "museo-sans",sans-serif;
      font-size: 1.136rem;
      color: #243236;
      font-weight: 500;
      line-height: 1.4;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      border-bottom: solid 3px #243236;

      strong {
        font-weight: 900;
      }
    }
  }

  .content {
    padding-top: 4.45rem;
    padding-bottom: 4.75rem;
  }

  .v-application {
    a {
      color: #243236;
      text-decoration: none;
      text-decoration: uppercase;
    }

    .img-contact {
      width: 75px;
    }
  }

  .custom-link {
    font-family: "bodoni-urw",serif;
    font-size: 2.045rem;
    font-weight: 300;
    font-style: italic;
    line-height: .71;
    color: #243236;
  }

  @media screen and (max-width: 960px) {
    .custom-link {
      font-size: 1.75rem;
    }

    .v-application {
      .img-contact {
        width: 50px;
      }
    }
  }

  @media screen and (max-width: 512px) {
    .custom-link {
      font-size: 1.5rem;
    }
  }
</style>

<script>
import Form from './Form.vue';

export default {
  components: {
    Form,
  },
};
</script>
